(function() {
    'use strict';

    angular.module('blocks.helpers', []);
})();
